import {
  RefObject,
  FocusEvent,
  ChangeEvent,
  HTMLInputTypeAttribute,
} from "react";
import classNames from "classnames";

import styles from "./style.module.scss";

export interface FloatingLabelInputProps {
  id: string;
  label: string;
  value: string;
  hidden?: boolean;
  isFocused?: boolean;
  errorMessage?: string | null;
  inputType?: HTMLInputTypeAttribute;
  inputRef?: RefObject<HTMLDivElement>;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const FloatingLabelInput = ({
  id,
  value,
  label,
  inputRef,
  isFocused = false,
  hidden = false,
  inputType = "text",
  errorMessage = null,
  onBlur,
  onFocus,
  onChange,
}: FloatingLabelInputProps) => {
  const labelClassnames = classNames(styles.label, {
    [styles.error]: errorMessage,
    [styles.focused]: isFocused && !errorMessage,
    [styles.floating]: isFocused || value || errorMessage,
  });

  const inputClassnames = classNames(styles.input, {
    [styles.errorBorder]: errorMessage,
    [styles.focusedBorder]: isFocused && !errorMessage,
  });

  const errorMessageClassnames = classNames(styles.errorMessage, {
    [styles.noErrorMessage]: !errorMessage,
  });

  return (
    <div className={styles.inputContainer}>
      <div className={styles.inputWrapper} ref={inputRef}>
        <input
          data-testid={id}
          hidden={hidden}
          id={id}
          value={value}
          type={inputType}
          placeholder={""}
          autoComplete="off"
          className={inputClassnames}
          onBlur={onBlur}
          onFocus={onFocus}
          onChange={onChange}
        />
        {hidden ? null : (
          <label htmlFor={id} className={labelClassnames}>
            {label}
          </label>
        )}
      </div>
      {errorMessage && (
        <div className={errorMessageClassnames}>{errorMessage}</div>
      )}
    </div>
  );
};

export default FloatingLabelInput;
